import { GraphQLError } from "graphql";
import { UNAUTHENTICATED } from "@hubcapp/constants";

export class HubcappGraphqlQLError extends GraphQLError {
  public readonly errorType: string;

  constructor(originalError: any) {
    super(originalError);
    if (originalError.errorType) {
      this.errorType = originalError.errorType;
    } else if (originalError.extensions && originalError.extensions.code) {
      this.errorType = originalError.extensions.code;
      if (this.errorType === UNAUTHENTICATED) {
        console.error("AUTHENTICATION ERROR", originalError); //@todo - Push this to Sentry or something
      }
    } else {
      this.errorType = "UNKNOWN";
    }
  }
}
